export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#002620',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#00E4BB',
  },
  {
    path: 'M348.16 325.632h68.096l140.8 365.568h-68.608l-34.304-96.768h-145.92L273.92 691.2h-66.048z m-22.528 220.16h111.616l-54.784-157.184h-1.536zM816.128 691.2h-57.344v-36.864h-1.024c-14.336 26.624-46.08 44.032-75.264 44.032-69.12 0-98.816-34.816-98.816-103.936V426.496h58.368V588.8c0 46.592 18.944 63.488 50.688 63.488 48.64 0 65.024-31.232 65.024-72.192v-153.6h58.368z',
    fill: '#00E4BB',
  },
]
